import { CONTROLS_IMAGES } from '../../../constants/image.constant';
import { DEVICE_TYPE } from '../../../constants/house.constants';

export const SEVERITY_LEVEL = {
    INFO: 1,
    WARNING: 2,
    ERROR: 3
};

export const icons = {
    [DEVICE_TYPE.AIR_COND]: CONTROLS_IMAGES.AIR_COND,
    [DEVICE_TYPE.ALARM_SYSTEM]: CONTROLS_IMAGES.ALARM_SYSTEM,
    [DEVICE_TYPE.BLENDER]: CONTROLS_IMAGES.BLENDER,
    [DEVICE_TYPE.COFFEE_MACHINE]: CONTROLS_IMAGES.COFFEE_MACHINE,
    [DEVICE_TYPE.COINS]: CONTROLS_IMAGES.COINS,
    [DEVICE_TYPE.COMPUTER]: CONTROLS_IMAGES.COMPUTER,
    [DEVICE_TYPE.COOKER]: CONTROLS_IMAGES.COOKER,
    [DEVICE_TYPE.COOKER_PLATE]: CONTROLS_IMAGES.COOKER_PLATE,
    [DEVICE_TYPE.CENTRAL_HEATING]: CONTROLS_IMAGES.CENTRAL_HEATING,
    [DEVICE_TYPE.DEFAULT]: CONTROLS_IMAGES.DEFAULT,
    [DEVICE_TYPE.DISHWASHER]: CONTROLS_IMAGES.DISHWASHER,
    [DEVICE_TYPE.DRYING_MACHINE]: CONTROLS_IMAGES.DRYING_MACHINE,
    [DEVICE_TYPE.EXCLAMATION]: CONTROLS_IMAGES.EXCLAMATION,
    [DEVICE_TYPE.ELECTRICAL_CAR]: CONTROLS_IMAGES.ELECTRICAL_CAR,
    [DEVICE_TYPE.ELECTRIC_HEATER]: CONTROLS_IMAGES.ELECTRIC_HEATER,
    [DEVICE_TYPE.FAN]: CONTROLS_IMAGES.FAN,
    [DEVICE_TYPE.FAN_HEATER]: CONTROLS_IMAGES.FAN_HEATER,
    [DEVICE_TYPE.FAX_MACHINE]: CONTROLS_IMAGES.FAX_MACHINE,
    [DEVICE_TYPE.FREEZER]: CONTROLS_IMAGES.FREEZER,
    [DEVICE_TYPE.FRIDGE]: CONTROLS_IMAGES.FRIDGE,
    [DEVICE_TYPE.IRON]: CONTROLS_IMAGES.IRON,
    [DEVICE_TYPE.GRILL]: CONTROLS_IMAGES.GRILL,
    [DEVICE_TYPE.HEATER]: CONTROLS_IMAGES.HEATING_THERMOSTAT,
    [DEVICE_TYPE.HAIR_DRYER]: CONTROLS_IMAGES.HAIR_DRYER,
    [DEVICE_TYPE.JACUZZI]: CONTROLS_IMAGES.JACUZZI,
    [DEVICE_TYPE.KETTLE]: CONTROLS_IMAGES.KETTLE,
    [DEVICE_TYPE.KITCHEN_HOOD]: CONTROLS_IMAGES.KITCHEN_HOOD,
    [DEVICE_TYPE.LAMP]: CONTROLS_IMAGES.LAMP,
    [DEVICE_TYPE.LIGHT]: CONTROLS_IMAGES.LIGHT,
    [DEVICE_TYPE.LIGHTNING]: CONTROLS_IMAGES.LIGHTNING,
    [DEVICE_TYPE.MICROWAVE]: CONTROLS_IMAGES.MICROWAVE,
    [DEVICE_TYPE.MOBILE_CHARGER]: CONTROLS_IMAGES.MOBILE_CHARGER,
    [DEVICE_TYPE.NOTEBOOK]: CONTROLS_IMAGES.NOTEBOOK,
    [DEVICE_TYPE.OVEN]: CONTROLS_IMAGES.OVEN,
    [DEVICE_TYPE.PLUGS]: CONTROLS_IMAGES.PLUG,
    [DEVICE_TYPE.PUMP]: CONTROLS_IMAGES.PUMP,
    [DEVICE_TYPE.POWER_SOCKET]: CONTROLS_IMAGES.POWER_SOCKET,
    [DEVICE_TYPE.PRINTER]: CONTROLS_IMAGES.PRINTER,
    [DEVICE_TYPE.RADIO]: CONTROLS_IMAGES.RADIO,
    [DEVICE_TYPE.SOUND_SYSTEM]: CONTROLS_IMAGES.SOUND_SYSTEM,
    [DEVICE_TYPE.SPA]: CONTROLS_IMAGES.SPA,
    [DEVICE_TYPE.SOLAR_HEATING]: CONTROLS_IMAGES.SOLAR_HEATING,
    [DEVICE_TYPE.SERVER]: CONTROLS_IMAGES.SERVER,
    [DEVICE_TYPE.SELF_STANDING_LAMP]: CONTROLS_IMAGES.SELF_STANDING_LAMP,
    [DEVICE_TYPE.STOVE]: CONTROLS_IMAGES.COOKER_PLATE,
    [DEVICE_TYPE.TV]: CONTROLS_IMAGES.TV,
    [DEVICE_TYPE.TOASTER]: CONTROLS_IMAGES.TOASTER,
    [DEVICE_TYPE.VENTILATION_SYSTEM]: CONTROLS_IMAGES.VENTILATION_SYSTEM,
    [DEVICE_TYPE.VACUUM_CLEANER]: CONTROLS_IMAGES.VACUUM_CLEANER,
    [DEVICE_TYPE.WASH_MACHINE]: CONTROLS_IMAGES.WASH_MACHINE,
    [DEVICE_TYPE.WATER_HEATER]: CONTROLS_IMAGES.WATER_HEATER,
    [DEVICE_TYPE.WARNING]: CONTROLS_IMAGES.WARNING
};


// WEBPACK FOOTER //
// ./~/pluton-core/lib/services/core/device/device.constant.js